import Cookies from "js-cookie";
export async function fetchPatientDataFromAPI(uhid) {
  const token = Cookies.get("jwt_token");
  try {
    // Example MongoDB API endpoint
    const response = await fetch(
      `https://epic-emr-api.azurewebsites.net/patients?ahcno=${uhid}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const responseObj = await response.json();

    if (!response.ok) {
      throw new Error(
        `Failed to fetch patient data: ${response.status} ${response.statusText}`
      );
    }
    if (responseObj.status === "success") {
      return responseObj.data;
    }
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
}

// Function to submit data to the AICVD model
export async function submitToAICVDModel(patientData) {
  const token = Cookies.get("jwt_token");

  try {
    const response = await fetch(
      `https://epic-emr-api.azurewebsites.net/aicvd`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(patientData),
      }
    );

    if (!response.ok) {
      throw new Error(
        `Failed to submit to AICVD model: ${response.status} ${response.statusText}`
      );
    }

    const responseObj = await response.json();
    return responseObj.Data;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
}
